import { Injectable } from '@angular/core';
import { EventsService } from './events.service';
import {
  SCREEN_SIZE_WAS_CHANGED,
  CLIENT_WIDTH_WAS_CHANGED
} from '../../app.constants';

@Injectable()
export class ScreenSizeService {
  SMALL = 'small';
  MIDDLE = 'middle';
  LARGE = 'large';

  SIZES = [
    this.SMALL,
    this.MIDDLE,
    this.LARGE
  ];

  private activeSize: string;

  constructor(private eventsService: EventsService) {}

  setClientWidth(width: number) {
    this.eventsService.trigger(CLIENT_WIDTH_WAS_CHANGED, width);
  }

  setSize(sizeType: string) {
    if (this.activeSize !== sizeType) {
      this.activeSize = sizeType;
      this.eventsService.trigger(SCREEN_SIZE_WAS_CHANGED, this.activeSize);
    }
  }

  getSize() {
    return this.activeSize;
  }

  getAllSizes() {
    return this.SIZES;
  }

  isLarge() {
    return this.activeSize === this.LARGE;
  }

  isMiddle() {
    return this.activeSize === this.MIDDLE;
  }

  isSmall() {
    return this.activeSize === this.SMALL;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/services/screen-size.service.ts